import React from "react";

import { InputField } from "affinityForm/fields";
import { Grid } from "affinityUI/elements/grid";
import { DataEntryGroup } from "affinityUI/form/components";

const DEFAULT_COLS = { xs: [1], lg: [1, 1] };

export const SectionAddress: React.FC = () => (
  <DataEntryGroup title="Address" id="address">
    <InputField name="contactDetails.address.line1">Address Line 1</InputField>
    <InputField name="contactDetails.address.line2">
      Address Line 2 <span>(optional)</span>
    </InputField>
    <Grid $cols={DEFAULT_COLS}>
      <InputField name="contactDetails.address.city">City</InputField>
      <InputField name="contactDetails.address.postcode">Postcode</InputField>
    </Grid>
  </DataEntryGroup>
);
